{
  "RESET_PASSWORD": {
    "TITLE": "Obnoviť heslo",
    "DESCRIPTION": "Zadajte e-mailovú adresu, ktorú používate na prihlásenie do kontaktného centra, a dostanete pokyny na obnovenie hesla.",
    "GO_BACK_TO_LOGIN": "Ak sa chcete vrátiť na prihlasovaciu stránku,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Zadajte svoj e-mail.",
      "ERROR": "Zadajte prosím platný e-mail."
    },
    "API": {
      "SUCCESS_MESSAGE": "Odkaz na obnovenie hesla bol odoslaný na váš e-mail.",
      "ERROR_MESSAGE": "Nepodarilo sa pripojiť k chatovaciemu serveru. Skúste to prosím znova."
    },
    "SUBMIT": "Odoslať"
  }
}
